import React from 'react';
import { createRoot } from 'react-dom/client';
import Dashboard from './App';

const elementContainer = document.querySelector<HTMLElement>('#dashboard-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<Dashboard />);
}
